export const adminConditions = (
  corpClientIds: number[],
): Record<string, any> => ({
  listUser: {
    or: [
      {
        userCorporateClients: {
          corporate_client_id: {
            in: corpClientIds,
          },
        },
      },
      {
        current_client_level: {
          corporate_client_id: {
            in: corpClientIds,
          },
        },
      },
    ],
  },
  listAssignment: {
    container: {
      corporate_client_id: {
        in: corpClientIds,
      },
    },
  },
  listContainer: {
    corporate_client_id: {
      in: corpClientIds,
    },
  },
  listCollectionBin: {
    corporate_client_id: {
      in: corpClientIds,
    },
  },
});
